const xAxisData = [];
const data1 = [];
const data2 = [];
const data3 = [];

for (let i = 0; i < 7; i++) {
  xAxisData.push(`date ${i + 1}`);
  data1.push(Math.floor(Math.random() * 20 + 1) + i);
  data2.push(Math.floor(Math.random() * 20 + 1) + i);
  data3.push(Math.floor(Math.random() * 20 + 1) + i);
}

const content = [
  { title: "Today", data: data1 },
  { title: "Last Week", data: data2 },
  { title: "Last Month", data: data3 }
];

export const serieObject = ({ title, data }) => ({
  name: title,
  type: "bar",
  data,
  animationDelay: function(idx) {
    return idx * 10;
  },
  barWidth: 30,
  itemStyle: {
    barBorderRadius: [5, 5, 0, 0],
    color: function (param) {
      // const color = ["#14323F", "green", "red", "purple", "yellow", "black"];
      // const color = ["#814ca7"];
      const color = ["#d2bfdf", "#c9b2d9", "#c0a5d3", "#b799cd", "#ae8cc6", "#a57fc0", "#9c72ba", "#9366b4", "#8a59ad", "#814ca7"]; // purple gradation
      // param.value is data.value
      return color[Math.min(Math.floor(param.value/10), color.length-1)]
    }
  },
  label: {
    show: true,
    position: "top",
    distance: 15,
    color: "#656565",
    fontSize: 10,
    formatter: data => {
      return `${data.value}`;
    }
  }
});

export const barDataMulti = {
  xAxis: {
    data: xAxisData,
    type: "category",
    silent: false,
    splitLine: {
      show: false
    }
  },
  yAxis: {
    show: false
  },
  legend: {
    show: true,
    data: content.map(item => item.title),
    align: "left"
  },
  series: content.map(item => serieObject(item))
};

export const barData = {
  xAxis: {
    data: xAxisData,
    type: "category",
    silent: false,
    splitLine: {
      show: false
    }
  },
  label: {
    show: true
  },
  yAxis: {
    show: false
  },
  tooltip: {
    show: true,
    trigger: 'item',
  },
  series: [serieObject({ title: "legend", data: data1 })]
};
